import {getLeaderBoardMock} from './LeaderBoardService.mock';
import {DI_TOKENS} from '@/di/di.tokens';
import {LeaderBoardStatusType, LeagueType} from '@/stores/LeaderBoardStore/LeaderBoardStore.constants';

import {injected} from 'brandi';

import {DevPanel} from '@/services/DevPanel/DevPanel';
import {LeaderBoardStore} from '@/stores/LeaderBoardStore/LeaderBoardStore';
import {Config} from '@/types';

import {ProjectDate} from '../../ProjectDate/ProjectDate';

enum TimerTypes {
  FiveDays = '5 дней',
  OneDay = '1 день',
  TenSeconds = '10 секунд',
  ZeroTime = '0 минут',
}

export class LeaderBoardDevPanel {
  public isInitialized: boolean = false;
  public config: {
    status: LeaderBoardStatusType;
    timer: TimerTypes | null;
    leagueType: LeagueType | null;
    playerScore: number;
  };

  constructor(
    private readonly gui: DevPanel,
    private readonly leaderBoardStore: LeaderBoardStore,
    private readonly configApp: Config,
    private readonly projectDate: ProjectDate,
  ) {}

  public init = (): void => {
    if (this.configApp.isProd) {
      return;
    }
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;
    this.config = {
      status: this.leaderBoardStore.getContent().status,
      timer: null,
      leagueType: this.leaderBoardStore.getPlayerLeague(),
      playerScore: this.leaderBoardStore.getPlayerScore(),
    };

    const folder = this.gui.getInstance().addFolder('LeaderBoard');

    folder
      .add(this.config, 'status', {
        New: LeaderBoardStatusType.New,
        Pending: LeaderBoardStatusType.Pending,
        Active: LeaderBoardStatusType.Active,
      })
      .onChange((v: LeaderBoardStatusType) => {
        this.leaderBoardStore.setContent(getLeaderBoardMock(v));
      });

    folder
      .add(this.config, 'timer', {
        null: '',
        ['5 дней']: TimerTypes.FiveDays,
        ['Сегодня']: TimerTypes.OneDay,
        ['10 секунд']: TimerTypes.TenSeconds,
        ['Идет перерасчет']: TimerTypes.ZeroTime,
      })
      .onChange((v: TimerTypes | null) => {
        if (v === null) {
          return;
        }

        let date: string = '';

        switch (v) {
          case TimerTypes.FiveDays:
            const fiveDays = this.projectDate.date;
            fiveDays.setDate(fiveDays.getDate() + 6);
            date = fiveDays.toISOString();
            break;
          case TimerTypes.OneDay:
            const oneDays = this.projectDate.date;
            oneDays.setDate(oneDays.getDate() + 1);
            date = oneDays.toISOString();
            break;
          case TimerTypes.TenSeconds:
            const tenSeconds = this.projectDate.date;
            tenSeconds.setSeconds(this.projectDate.date.getSeconds() + 10);
            date = tenSeconds.toISOString();
            break;
          case TimerTypes.ZeroTime:
            date = this.projectDate.date.toISOString();
            break;
        }

        this.leaderBoardStore.setNextRecalculationAt(date);
      });

    folder
      .add(this.config, 'leagueType', {
        Bronze: LeagueType.Bronze,
        Silver: LeagueType.Silver,
        Gold: LeagueType.Gold,
        Diamond: LeagueType.Diamond,
      })
      .onChange(this.leaderBoardStore.setPlayerLeague);

    folder.add(this.config, 'playerScore').onChange(this.leaderBoardStore.setPlayerScore);
  };
}

injected(LeaderBoardDevPanel, DI_TOKENS.devPanel, DI_TOKENS.leaderBoardStore, DI_TOKENS.config, DI_TOKENS.projectDate);
